import styled from "styled-components";
import { BaseGridContainer } from "views/utils/styles";

export const PcCdBannerContainer = styled(BaseGridContainer)`
	margin: 0 auto;
	display: block;
	font-size: 0;
	position: relative;
`;

export const PcCdBannerExpired = styled.div`
	width: 1200px;
	margin: 0 auto;
	height: 76px;
	background: rgba(51, 51, 51, 0.85);

	h1 {
		font-size: 20px;
		font-weight: 400;
		color: #fff;
		line-height: 76px;
		text-align: center;
		margin: 0;
	}
`;

export const PcCdBannerContent = styled.div`
	position: absolute;
	display: flex;
	height: 100%;
	width: 100%;
	left: 0;
	top: 0;
`;

export const PcCdBannerBox = styled.div`
	height: 100px;
	margin: auto;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	color: #fff;

	& > h1 {
		font-size: 24px;
		font-weight: 500;
		line-height: 29px;
		margin: 0;
		text-align: center;
	}

	& > div {
		text-align: center;
	}
`;

export const PcCdBannerNum = styled.span`
	display: inline-block;
	width: 45px;
	height: 58px;
	border-radius: 3px;
	background: #fff;
	box-shadow: 0 -3px 0 0 rgba(0, 0, 0, 0.1) inset;
	text-align: center;
	line-height: 58px;
	font-size: 24px;
	font-family: Avenir-Heavy;
	font-weight: bold;
	color: #333;

	&:not(:first-child) {
		margin-left: 9px;
	}
`;

export const PcCdBannerSymbol = styled.span`
	display: inline-block;
	margin: 0 4px 0 13px;
	height: 58px;
	width: 8px;
	font-size: 24px;
	line-height: 58px;
	font-family: Avenir-heavy;
`;
